import { render, staticRenderFns } from "./PnetMessageView.vue?vue&type=template&id=4a6a68c0"
import script from "./PnetMessageView.vue?vue&type=script&lang=js"
export * from "./PnetMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6a68c0')) {
      api.createRecord('4a6a68c0', component.options)
    } else {
      api.reload('4a6a68c0', component.options)
    }
    module.hot.accept("./PnetMessageView.vue?vue&type=template&id=4a6a68c0", function () {
      api.rerender('4a6a68c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageView.vue"
export default component.exports